/**
 * Standalone Spectrum Mini PDP
 * Matches the shoppable video mini PDP (spectrum-pdp__* classes) exactly.
 * Fetches product data via a Liquid section endpoint to get inventory quantities.
 */
(function () {
  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function fetchProductData(handle) {
    return fetch('/products/' + handle + '?section_id=spectrum-pdp-data')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var jsonEl = doc.querySelector('#spectrum-pdp-json');
        if (!jsonEl) throw new Error('Product data not found');
        return JSON.parse(jsonEl.textContent);
      });
  }

  function buildDialog(product) {
    var images = product.images || [];
    var variants = product.variants || [];
    var firstVariant = variants[0] || {};

    // Prices are pre-formatted from Liquid (e.g. "₹1,743.00")
    var price = firstVariant.price || product.price || '';
    var comparePrice = firstVariant.compare_at_price || product.compare_at_price || '';

    // Calculate discount from formatted prices — parse numbers out
    var discount = 0;
    if (comparePrice && comparePrice !== price) {
      var currentNum = parseFloat((price + '').replace(/[^\d.]/g, ''));
      var compareNum = parseFloat((comparePrice + '').replace(/[^\d.]/g, ''));
      if (compareNum > currentNum && compareNum > 0) {
        discount = Math.round((1 - currentNum / compareNum) * 100);
      }
    }

    // Stock status for first variant
    var selectedVariant = variants.length > 0 ? variants[0] : null;
    var quantity = selectedVariant ? (selectedVariant.inventory_quantity || 0) : (product.inventory_quantity || 0);

    var dialog = document.createElement('dialog');
    dialog.className = 'spectrum-modal__mini-pdp';

    dialog.innerHTML =
      '<div class="spectrum-pdp">' +
        '<button class="spectrum-pdp__close" type="button" aria-label="Close">' +
          '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
            '<line x1="18" y1="6" x2="6" y2="18"></line>' +
            '<line x1="6" y1="6" x2="18" y2="18"></line>' +
          '</svg>' +
        '</button>' +

        '<div class="spectrum-pdp__left">' +
          (images.length > 0
            ? '<div class="spectrum-pdp__gallery"><div class="spectrum-pdp__gallery-scroll">' +
              images.map(function (img, idx) {
                return '<div class="spectrum-pdp__gallery-item">' +
                  '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(product.title || 'Product') + ' - Image ' + (idx + 1) + '" class="spectrum-pdp__gallery-image" />' +
                '</div>';
              }).join('') +
              '</div></div>'
            : '<div class="spectrum-pdp__gallery"><div class="spectrum-pdp__gallery-scroll">' +
              '<div class="spectrum-pdp__gallery-item">' +
                '<img src="' + escapeHtml(product.image || '') + '" alt="' + escapeHtml(product.title || 'Product') + '" class="spectrum-pdp__gallery-image" />' +
              '</div>' +
              '</div></div>'
          ) +

          '<div class="spectrum-pdp__action-icons">' +
            '<button class="spectrum-pdp__action-icon" type="button" aria-label="Share product">' +
              '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
                '<path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/>' +
                '<polyline points="16,6 12,2 8,6"/>' +
                '<line x1="12" y1="2" x2="12" y2="15"/>' +
              '</svg>' +
            '</button>' +
            '<button class="spectrum-pdp__action-icon" type="button" aria-label="External link" onclick="window.location.href=\'' + escapeHtml(product.url || '/products/' + product.handle) + '\'">' +
              '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
                '<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>' +
                '<polyline points="15,3 21,3 21,9"/>' +
                '<line x1="10" y1="14" x2="21" y2="3"/>' +
              '</svg>' +
            '</button>' +
          '</div>' +
        '</div>' +

        '<div class="spectrum-pdp__right">' +
          '<h1 class="spectrum-pdp__title">' + escapeHtml(product.title || 'Product') + '</h1>' +

          '<div class="spectrum-pdp__price-section">' +
            '<span class="spectrum-pdp__current-price">' + escapeHtml(price) + '</span>' +
            (comparePrice && discount > 0
              ? '<span class="spectrum-pdp__original-price">' + escapeHtml(comparePrice) + '</span>' +
                '<span class="spectrum-pdp__discount">' + discount + '% OFF</span>'
              : '') +
          '</div>' +

          (variants.length > 1
            ? '<div class="spectrum-pdp__size-section">' +
                '<div class="spectrum-pdp__size-options">' +
                  variants.map(function (v, idx) {
                    return '<button class="spectrum-pdp__size-option' + (idx === 0 ? ' selected' : '') + '"' +
                      ' type="button"' +
                      ' data-variant-id="' + escapeHtml(String(v.id)) + '"' +
                      (v.available ? '' : ' disabled') + '>' +
                      escapeHtml(v.title) +
                    '</button>';
                  }).join('') +
                '</div>' +
              '</div>'
            : '') +

          '<div class="spectrum-pdp__stock-status">' +
            (function () {
              if (quantity > 0 && quantity <= 20) {
                return '<span class="spectrum-pdp__stock-indicator">\uD83D\uDD25 Low in stock - Only ' + quantity + ' available</span>';
              } else if (quantity > 20) {
                return '<span class="spectrum-pdp__stock-indicator in-stock">In Stock</span>';
              }
              return '';
            })() +
          '</div>' +

          '<div class="spectrum-pdp__actions">' +
            (function () {
              if (product.available && quantity > 0) {
                return '<button class="spectrum-pdp__add-to-bag" type="button">ADD TO BAG</button>';
              } else {
                return '<button class="spectrum-pdp__add-to-bag disabled" type="button" disabled>OUT OF STOCK</button>';
              }
            })() +
          '</div>' +
        '</div>' +
      '</div>';

    return { dialog: dialog, variants: variants };
  }

  function closeDialog(dialog) {
    dialog.classList.remove('visible');
    setTimeout(function () {
      dialog.close();
      dialog.remove();
    }, 200);
  }

  function addToCartAndOpenDrawer(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] }),
    })
      .then(function () {
        return fetch(window.location.pathname + '?section_id=cart-drawer');
      })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var cd = document.querySelector('cart-drawer');
        if (!cd) return;
        var newCartDrawer = doc.querySelector('cart-drawer');
        if (newCartDrawer) {
          cd.innerHTML = newCartDrawer.innerHTML;
          cd.querySelectorAll('script').forEach(function(s) {
            var n = document.createElement('script');
            n.textContent = s.textContent;
            s.parentNode.replaceChild(n, s);
          });
        }
        cd.classList.remove('is-empty');
        var ov = cd.querySelector('#CartDrawer-Overlay');
        if (ov) ov.addEventListener('click', function() { cd.close(); });
        cd.open();
        if (window.loadCartRecommendations) window.loadCartRecommendations();
        return fetch('?section_id=cart-icon-bubble');
      })
      .then(function (r) { if (r) return r.text(); })
      .then(function (h) {
        if (!h) return;
        var p = new DOMParser();
        var d = p.parseFromString(h, 'text/html');
        var nb = d.querySelector('.shopify-section');
        var cb = document.getElementById('cart-icon-bubble');
        if (nb && cb) cb.innerHTML = nb.innerHTML;
      });
  }

  function wireUpDialog(dialog, product, variants) {
    // Close button
    var closeBtn = dialog.querySelector('.spectrum-pdp__close');
    if (closeBtn) closeBtn.addEventListener('click', function () { closeDialog(dialog); });

    // Backdrop click
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) closeDialog(dialog);
    });

    // Escape key
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDialog(dialog);
    });

    // Size selection
    var sizeOptions = dialog.querySelectorAll('.spectrum-pdp__size-option');
    var selectedVariantId = null;

    sizeOptions.forEach(function (option) {
      option.addEventListener('click', function () {
        if (option.disabled) return;
        sizeOptions.forEach(function (o) { o.classList.remove('selected'); });
        option.classList.add('selected');
        selectedVariantId = option.dataset.variantId;

        // Find selected variant
        var sv = variants.find(function (v) { return String(v.id) === String(selectedVariantId); });
        if (!sv) return;

        var qty = sv.inventory_quantity || 0;

        // Update stock status
        var stockDiv = dialog.querySelector('.spectrum-pdp__stock-status');
        if (stockDiv) {
          if (qty > 0 && qty <= 20) {
            stockDiv.innerHTML = '<span class="spectrum-pdp__stock-indicator">\uD83D\uDD25 Low in stock - Only ' + qty + ' available</span>';
          } else if (qty > 20) {
            stockDiv.innerHTML = '<span class="spectrum-pdp__stock-indicator in-stock">In Stock</span>';
          } else {
            stockDiv.innerHTML = '';
          }
        }

        // Update button state
        var atcBtn = dialog.querySelector('.spectrum-pdp__add-to-bag');
        if (atcBtn) {
          if (sv.available && qty > 0) {
            atcBtn.disabled = false;
            atcBtn.classList.remove('disabled');
            atcBtn.textContent = 'ADD TO BAG';
          } else {
            atcBtn.disabled = true;
            atcBtn.classList.add('disabled');
            atcBtn.textContent = 'OUT OF STOCK';
          }
        }

        // Update price
        var priceEl = dialog.querySelector('.spectrum-pdp__current-price');
        if (priceEl) priceEl.textContent = sv.price || '';

        var origEl = dialog.querySelector('.spectrum-pdp__original-price');
        var discEl = dialog.querySelector('.spectrum-pdp__discount');

        if (sv.compare_at_price && sv.compare_at_price !== sv.price) {
          var currentNum = parseFloat((sv.price + '').replace(/[^\d.]/g, ''));
          var compareNum = parseFloat((sv.compare_at_price + '').replace(/[^\d.]/g, ''));
          if (compareNum > currentNum && compareNum > 0) {
            var disc = Math.round((1 - currentNum / compareNum) * 100);
            if (origEl) { origEl.textContent = sv.compare_at_price; origEl.style.display = ''; }
            if (discEl) { discEl.textContent = disc + '% OFF'; discEl.style.display = ''; }
          } else {
            if (origEl) origEl.style.display = 'none';
            if (discEl) discEl.style.display = 'none';
          }
        } else {
          if (origEl) origEl.style.display = 'none';
          if (discEl) discEl.style.display = 'none';
        }
      });
    });

    // Set initial variant
    if (sizeOptions.length > 0) {
      var first = Array.from(sizeOptions).find(function (o) { return !o.disabled; });
      if (first) selectedVariantId = first.dataset.variantId;
      else if (sizeOptions[0]) selectedVariantId = sizeOptions[0].dataset.variantId;
    } else if (variants.length > 0) {
      var fv = variants.find(function (v) { return v.available; });
      selectedVariantId = String((fv || variants[0]).id);
    }

    // ATC button
    var addBtn = dialog.querySelector('.spectrum-pdp__add-to-bag');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        var vid = selectedVariantId || (variants[0] && String(variants[0].id));
        if (!vid) return;

        addBtn.disabled = true;
        addBtn.textContent = 'ADDING...';

        // Close dialog immediately (optimistic)
        closeDialog(dialog);

        // Add to cart and open drawer in background
        addToCartAndOpenDrawer(vid).catch(function (err) {
          console.error('[Spectrum PDP ATC]', err);
        });
      });
    }

    // Share button
    var shareBtn = dialog.querySelector('.spectrum-pdp__action-icon[aria-label="Share product"]');
    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        if (navigator.share) {
          navigator.share({ title: product.title, url: product.url || '/products/' + product.handle });
        }
      });
    }
  }

  window.openSpectrumPDP = function (handle) {
    fetchProductData(handle)
      .then(function (product) {
        var result = buildDialog(product);
        document.body.appendChild(result.dialog);
        result.dialog.showModal();
        wireUpDialog(result.dialog, product, result.variants);
        setTimeout(function () { result.dialog.classList.add('visible'); }, 10);
      })
      .catch(function (err) {
        console.error('Failed to open spectrum PDP:', err);
      });
  };
})();
